<div>
  <img src="assets/images/access-denied.svg" alt="Acesso Negado">
  <strong>Opssssssss!</strong>
  <span>A página que você procura não foi encontrada.</span>
</div>
